var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxoutlinequestionCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.2C0 3.26667 3.26667 0 7.2 0C11.1333 0 14.4 3.26667 14.4 7.2C14.4 11.1333 11.1333 14.4 7.2 14.4C3.26667 14.4 0 11.1333 0 7.2C0 7.2 0 7.2 0 7.2ZM1.06667 7.2C1.06667 10.6 3.86667 13.3333 7.2 13.3333C10.5333 13.3333 13.3333 10.6 13.3333 7.2C13.3333 3.8 10.6 1.06667 7.2 1.06667C3.8 1.06667 1.06667 3.8 1.06667 7.2C1.06667 7.2 1.06667 7.2 1.06667 7.2Z",
    fill: "#546E7A",
    fillRule: "evenodd",
    transform: "translate(0.8 0.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60136 6.86667C2.33469 6.86667 2.06803 6.66667 2.06803 6.33333C2.06803 6.33333 2.06803 5.4 2.06803 5.4C2.06803 4.53333 2.66803 4 3.00136 3.86667C3.00136 3.86667 3.13469 3.8 3.13469 3.8C4.20136 3.53333 4.13469 2.46667 4.13469 2.4C4.13469 2.13333 4.06803 0.999999 2.53469 0.999999C2.00136 0.999999 1.66803 1.13333 1.40136 1.4C0.934694 1.86667 1.00136 2.8 1.00136 2.8C1.00136 3.06667 0.801361 3.33333 0.534694 3.33333C0.268028 3.33333 0.00136042 3.13333 0.00136042 2.86667C0.00136042 2.8 -0.0653062 1.53333 0.734694 0.733333C1.20136 0.266667 1.80136 0 2.60136 0C3.40136 0 4.00136 0.266667 4.46803 0.666667C5.1347 1.33333 5.1347 2.33333 5.1347 2.33333C5.20136 3 4.86803 4.4 3.40136 4.8C3.33469 4.86667 3.06803 4.86667 3.06803 5.4C3.06803 5.4 3.06803 6.33333 3.06803 6.33333C3.13469 6.66667 2.86803 6.86667 2.60136 6.86667C2.60136 6.86667 2.60136 6.86667 2.60136 6.86667Z",
    fill: "#546E7A",
    fillRule: "evenodd",
    transform: "translate(5.399 3.533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.466667C0 0.208934 0.208934 0 0.466666 0C0.7244 0 0.933333 0.208934 0.933333 0.466667C0.933333 0.7244 0.7244 0.933333 0.466666 0.933333C0.208934 0.933333 0 0.7244 0 0.466667Z",
    fill: "#546E7A",
    fillRule: "evenodd",
    transform: "translate(7.533 11.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlinequestionCricle);
export default __webpack_public_path__ + "static/media/vuesaxoutlinequestion-cricle.58401e0da14c0f30bf2874db78c9e027.svg";
export { ForwardRef as ReactComponent };